import Vue from "vue";
import Router from "vue-router";
import orderQuery from "./orderQuery"; // 单号查询
import orderList from "./orderList"; // 订单列表
import logisticsQuery from "./logisticsQuery";

const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};

var routes = [];
routes.push(...orderQuery);
routes.push(...logisticsQuery);
routes.push(...orderList);

Vue.use(Router);
var router = new Router({
  routes: routes
});

export default router;
